<ion-card class="ion-text-center ion-margin keep-size">
  <ion-card-content>
    <div *ngIf="!maxReached">
      <ion-icon name="cloud-offline-outline" size="large"></ion-icon>
      <p>{{'wrn.error_has_occurred'|translate}}</p>
      <ion-button fill="clear" (click)="doRetry()">{{'btn.error_retry'|translate}}</ion-button>
    </div>
    <div *ngIf="maxReached">
      <ion-icon name="sad-outline" size="large" color="danger"></ion-icon>
      <p><ion-text color="danger">{{'wrn.error_max_attempts_reached'|translate}}</ion-text></p>
    </div>
  </ion-card-content>
</ion-card>
